export default __webpack_public_path__ + "static/soucek-7669edcc2376671ac86a9532cd73e47d.jpg";